import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-lock",
  "use": "icon-icon-lock-usage",
  "viewBox": "0 0 19.7 25.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.7 25.1\" id=\"icon-icon-lock\"><title>资源 1</title><g id=\"icon-icon-lock_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-lock_图层_1-2\" data-name=\"图层 1\"><path d=\"M14.8,11.3a1,1,0,0,1-1-1V5.9a4,4,0,0,0-7.9,0v4.4a1,1,0,0,1-1,1,1.1,1.1,0,0,1-1-1V5.9a6,6,0,0,1,11.9,0v4.4A1.1,1.1,0,0,1,14.8,11.3Z\" /><path d=\"M12,25.1H7.7a7.7,7.7,0,0,1,0-15.4H12a7.7,7.7,0,0,1,0,15.4ZM7.7,11.7A5.8,5.8,0,0,0,2,17.4a5.7,5.7,0,0,0,5.7,5.7H12a5.7,5.7,0,0,0,5.7-5.7A5.8,5.8,0,0,0,12,11.7Z\" /><path d=\"M9.8,20.1a1,1,0,0,1-1-1V14.8a1,1,0,0,1,1-1,.9.9,0,0,1,1,1v4.3A.9.9,0,0,1,9.8,20.1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-lock.svg
// module id = ct1T
// module chunks = 75